// extracted by mini-css-extract-plugin
module.exports = {"root":"GuestHeader_root__m9i5e","closeIcon":"GuestHeader_closeIcon__3Cz34","successStoriesBtn":"GuestHeader_successStoriesBtn__31Nh7"};